export default "__VITE_ASSET__sSgKM7lpy2YT210BHuEaKw__"